<template>
  <div>
    
    <!-- Floating Button -->
    <floating-button @click="save()" save v-if="isEditing"/>
    
    <v-form ref="form" lazy-validation>
      <v-card :loading="isLoadingData">
        <v-card-title primary-title>
          <v-btn small color="primary" class="mr-4" @click="clickBack()">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          Día <span v-if="!isLoadingData">&nbsp;{{ isNew ? days.length + 1 : currentDay }}&nbsp;</span>
          <template v-if="authUser">
            | &nbsp;
            <span v-if="!isEditing">{{ formatDate(item.date) }}</span>
            <v-menu
              v-else
              v-model="menu"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Fecha"
                  :value="formatDate(item.date)"
                  class="shrink"
                  :rules="rules"
                  required
                  readonly
                  outlined
                  dense
                  hide-details
                  v-on="on"
                ></v-text-field>
                <!-- <v-btn icon v-on="on">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn> -->
              </template>
              <v-date-picker v-model="item.date" @input="menu = false"></v-date-picker>
            </v-menu>
          </template>
        </v-card-title>
        <v-divider/>
        <v-card-text v-if="authUser">
          <v-container>
            <v-row align="center">
              <!-- Day Content -->
              <v-col cols="12">
                <v-stepper v-model="step" vertical class="pa-0 elevation-0">

                  <!-- Basic Data -->
                  <v-stepper-step step="1" :editable="!isNew">Datos basicos</v-stepper-step>
                  <v-stepper-content step="1">
                    <v-row align="start" justify="space-around">
                      <!-- Checkboxes -->
                      <v-col cols="12">
                        <v-checkbox
                          label="¿Ha rellenado el control previo al inicio de los trabajos?"
                          v-model="item.has_filled_forms_required_before_start"
                          color="primary"
                          class="mx-2"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                          :true-value="1"
                          :false-value="0"
                        ></v-checkbox>
                        <v-checkbox
                          label="¿Ha verificado la autorización de acceso a parque?"
                          v-model="item.has_checked_farm_access_auth"
                          color="primary"
                          class="mx-2"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                          :true-value="1"
                          :false-value="0"
                        ></v-checkbox>
                        <v-checkbox
                          label="¿Ha seguido el procedimiento de trabajo?"
                          v-model="item.has_followed_work_procedures"
                          color="primary"
                          class="mx-2"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                          :true-value="1"
                          :false-value="0"
                        ></v-checkbox>
                      </v-col>
                      <!-- Suspended Platform Count -->
                      <v-col cols="6" v-if="work_type === reparacion">
                        <v-row class="px-3">
                          <v-col cols="12" class="grey lighten-4 round-corners">
                            <span class="font-weight-bold mr-4">Contador del uso de la plataforma suspendida</span>
                          </v-col>
                          <!-- Start Count -->
                          <v-col cols="6">
                            <v-text-field
                              label="Inicial"
                              v-model.number="item.suspended_platform_day_start_count"
                              type="number"
                              :readonly="!isEditing"
                            ></v-text-field>
                          </v-col>
                          <!-- End Count -->
                          <v-col cols="6">
                            <v-text-field
                              label="Final"
                              v-model.number="item.suspended_platform_day_end_count"
                              type="number"
                              :readonly="!isEditing"
                              :rules="platformRules"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <!-- Generator Count -->
                      <v-col cols="6" v-if="work_type === reparacion">
                        <v-row class="px-3">
                          <v-col cols="12" class="grey lighten-4 round-corners">
                            <span class="font-weight-bold mr-4">Contador del uso del generador</span>
                          </v-col>
                          <!-- Start Count -->
                          <v-col cols="6">
                            <v-text-field
                              label="Inicial"
                              v-model.number="item.generator_day_start_count"
                              type="number"
                              :readonly="!isEditing"
                            ></v-text-field>
                          </v-col>
                          <!-- End Count -->
                          <v-col cols="6">
                            <v-text-field
                              label="Final"
                              v-model.number="item.generator_day_end_count"
                              type="number"
                              :readonly="!isEditing"
                              :rules="generatorRules"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-stepper-content>

                  <!-- Data -->
                  <v-stepper-step step="2" :editable="!isNew">Datos</v-stepper-step>
                  <v-stepper-content step="2">
                    <v-row align="start" justify="space-around">
                      <!-- Work Blocks -->
                      <v-col cols="4">
                        <work-block :isEditing="isEditing" :day="item" :key="component" v-if="item.id"/>
                      </v-col>
                      <!-- Shut Down Blocks -->
                      <v-col cols="8">
                        <shut-down-block :isEditing="isEditing" :day="item" :key="component" v-if="item.id"/>
                      </v-col>
                      <!-- Time Worked Per Damage -->
                      <v-col cols="12" v-if="work_type === reparacion">
                        <time-worked-per-damage
                          :isEditing="isEditing"
                          :items="timeWorkedPerDamageList"
                          :headers="timeWorkedPerDamageHeaders"
                          :options="bladeDamages"
                          title="Tiempo dedicado a cada año <br> AG | Posición | Código del daño | Grado"
                          titleDialog="tiempo dedicado al daño"
                          labelOptions="Daño"
                          hint="AG | Posición | Código del daño | Grado"
                          persistent-hint
                          :key="component"
                          @save="saveTimeWorkedPerDamage($event)"
                          @delete="deleteTimeWorkedPerDamage($event)"/>
                      </v-col>
                      <!-- Generated Waste -->
                      <v-col cols="12" v-if="work_type === reparacion">
                        <generated-waste
                          :isEditing="isEditing"
                          :items="generatedWastesList"
                          :headers="generatedWasteHeaders"
                          :options="wasteTypes"
                          title="Residuos generados"
                          titleDialog="residuo generado"
                          labelOptions="Tipo de residuo"
                          labelQuantity="Cantidad (kg)"
                          :key="component"
                          @save="saveWaste($event)"
                          @delete="deleteWaste($event)"/>
                      </v-col>
                    </v-row>
                  </v-stepper-content>

                </v-stepper>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-form>

  </div>
</template>

<script>
import FloatingButton from "@/components/FloatingButton";
import WorkBlock from "./WorkBlock";
import ShutDownBlock from "./ShutDownBlock";
import GeneratedWaste from '@/components/InterventionReview/SelectAndNumber'
import TimeWorkedPerDamage from '@/components/InterventionReview/SelectAndNumber'
import STATES from '@/models/States'
import Util from "@/util/index";
import moment from 'moment'

export default {
  props: {
    work_type: [Number, String],
    isEditing: { type: Boolean, default: false },
    day: { type: Object, default: () => {} },
  },
  components: {
    FloatingButton,
    WorkBlock,
    ShutDownBlock,
    GeneratedWaste,
    TimeWorkedPerDamage,
  },
  data: () => ({
    item: {
      date: moment().format('YYYY-MM-DD')
    },
    component: 0,
    step: 1,
    authUser: false,
    menu: false,
    isLoadingData: false,
    isLoadingFiles: false,
    inspeccion: STATES.WORK_ORDER_TYPE_INSPECCION,
    reparacion: STATES.WORK_ORDER_TYPE_REPARACION,
    rules: [v => !!v || 'Obligatorio.'],
    // Suspended Plataform Count
    suspendedPlatformCountList: [],
    // Generator Count
    generatorCountList: [],
    // Generated Waste
    generatedWasteHeaders: [
      { text: "Tipo de residuo ", value: "waste_type.name", align: "center" },
      { text: "Cantidad (kg)", value: "quantity", align: "center" },
      { text: "Acciones", value: "action", sortable: false, align: "center" }
    ],
    // Time Worked Per Damage
    timeWorkedPerDamageHeaders: [
      { text: "Daño", value: "name", align: "center" },
      { text: "Tiempo dedicado", value: "time_worked", align: "center" },
      { text: "Acciones", value: "action", sortable: false, align: "center" }
    ],
  }),
  watch: {
    day() {
      this.init()
    }
  },
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    isNew () {
      return !this.item.id
    },
    title () {
      return this.isNew ? 'Modificar' : 'Añadir'
    },
    currentDay() {
      let idx = 0
      for (let i=0; i < this.days.length; i++) {
        const day = this.days[i]
        if (day.id === this.item.id) {
          idx = i
          break;
        }
      }
      return idx + 1
    },
    platformRules() {
      return this.item.suspended_platform_day_start_count >= 0
      ? [v => v >= this.item.suspended_platform_day_start_count || 'Debe ser igual o mayor al contador inicial.']
      : []
    },
    generatorRules() {
      return this.item.generator_day_start_count >= 0
      ? [v => v >= this.item.generator_day_start_count || 'Debe ser igual o mayor al contador inicial.']
      : []
    },
    days () {
      return this.$store.state.interventions.days.list
    },
    wasteTypes () {
      return this.$store.state.interventions.options.wasteTypes
    },
    generatedWastesList () {
      return this.$store.state.interventions.generatedWastes.list
    },
    timeWorkedPerDamageList () {
      return this.$store.state.interventions.timeWorkedPerDamage.list
    },
    bladeDamages () {
      return this.$store.state.interventions.bladeDamages.list
    }
  },
  methods: {
    formatDate(date) {
      return Util.formatDate(date)
    },
    clickBack () {
      this.$emit('init')
      this.$emit('clickBack')
    },
    errorAlert (error, altText) {
      if (error.response.status === 403 ) {
        this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
          color: "error",
          x: "center",
          y: "top",
          icon: "mdi-information",
          timeout: 0,
          showClose: true,
          closeText: "Cerrar"
        });
        this.$router.push({ name: 'home'})
      } else {
        let errorToastMessage = `Ha ocurrido un error ${altText}`
        Util.showErrorToast(this, error, errorToastMessage);
      }
    },
    save () {
      if (this.$refs.form.validate()) this.isNew ? this.create() : this.edit()
    },
    create () {
      this.loading = true
      const body = {
        ...this.item,
        work_intervention_id: this.$route.params.id,
        work_order_id: this.$route.params.work_order,
      }
      body.date = this.item.date
      this.$store.dispatch('interventions/days/create', body)
        .then(response => {
          const data = response.data.data
          this.init(data.id)
          this.$toast("Día guardado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
        })
        .catch(error => {
          var errorToastMessage = "Ha ocurrido un error guardando el día."
          Util.showErrorToast(this, error, errorToastMessage);
        })
        .finally(() => {
          this.loading = false
        })
    },
    edit () {
      this.loading = true
      const body = {
        ...this.item,
        work_order_id: this.$route.params.work_order,
      }
      body.date = this.item.date
      this.$store.dispatch('interventions/days/edit', body)
        .then(() => {
          this.$toast("Día guardado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.$emit('init')
          this.clickBack()
        })
        .catch(error => {
          var errorToastMessage = "Ha ocurrido un error guardando el día."
          Util.showErrorToast(this, error, errorToastMessage);
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Generated Waste
    async getWastes (init) {
      if (init) {
        this.isLoadingData = true
        await this.$store.dispatch('interventions/options/getWasteTypes')
          .catch(error => {
            let altText = "lista de tipos residuos"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
      if (this.item.id) {
        this.isLoadingData = true
        const body = {
          id: this.item.id,
          work_intervention_id: this.$route.params.id,
          work_order_id: this.$route.params.work_order,
          with: 'generatedWastes'
        }
        await this.$store.dispatch('interventions/generatedWastes/list', body)
          .catch(error => {
            let altText = "cargando la lista de residuos"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
    },
    saveWaste (params) {
      this.loading = true
      const item = {
        work_intervention_day_id: this.item.id,
        waste_type_id: params.option,
        quantity: params.quantity
      }
      if (params.id) {
        item.id = params.id
        this.$store.dispatch('interventions/generatedWastes/edit', item)
          .then(() => {
            this.$toast("Residuo modificado correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.getWastes()
          })
          .catch(error => {
            let altText = "modificando el residuo."
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.loading = false
          })
       } else {
        this.$store.dispatch('interventions/generatedWastes/create', item)
          .then(() => {
            this.$toast("Residuo creado correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.getWastes()
          })
          .catch(error => {
            let altText = "creando el residuo."
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.loading = false
          })
       }
    },
    deleteWaste (item) {
      this.loading = true
      this.$store.dispatch('interventions/generatedWastes/delete', item.id)
        .then(() => {
          this.$toast("Residuo eliminado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.getWastes()
        })
        .catch(error => {
          let altText = "eliminando el residuo."
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Time Worked Per Damage
    async getTimeWorkedPerDamages () {
      this.isLoadingData = true
      const body = {
        id: this.item.id,
        work_intervention_id: this.$route.params.id,
        work_order_id: this.$route.params.work_order,
        with: 'timeWorkedPerDamagePerDays'
      }
      await this.$store.dispatch('interventions/timeWorkedPerDamage/list', body)
        .catch(error => {
          let altText = "cargando la lista de tiempo dedicado a daños"
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.isLoadingData = false
        })
    },
    saveTimeWorkedPerDamage (params) {
      this.loading = true
      const item = {
        work_intervention_day_id: this.item.id,
        blade_damage_id: params.option,
        time_worked: params.quantity
      }
      if (params.id) {
        item.id = params.id
        this.$store.dispatch('interventions/timeWorkedPerDamage/edit', item)
          .then(() => {
            this.$toast("Tiempo dedicado modificado correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.getTimeWorkedPerDamages()
          })
          .catch(error => {
            let altText = "modificando el tiempo dedicado."
            this.errorAlert(error, altText)
          })
        .finally(() => {
          this.loading = false
        })
      } else {
        this.$store.dispatch('interventions/timeWorkedPerDamage/create', item)
          .then(() => {
            this.$toast("Tiempo dedicado creado correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.getTimeWorkedPerDamages()
          })
          .catch(error => {
            let altText = "creando el tiempo dedicado."
            this.errorAlert(error, altText)
          })
        .finally(() => {
          this.loading = false
        })
      }
    },
    deleteTimeWorkedPerDamage (item) {
      this.loading = true
      this.$store.dispatch('interventions/timeWorkedPerDamage/delete', item.id)
        .then(() => {
          this.$toast("Tiempo dedicado eliminado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.getTimeWorkedPerDamages()
        })
        .catch(error => {
          let altText = "eliminando el tiempo dedicado."
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Init
    async init (day_id) {
      const id = day_id || this.day.id
      if (id) {
        this.isLoadingData = true
        const body = {
          id: id,
          work_intervention_id: this.$route.params.id,
          work_order_id: this.$route.params.work_order,
        }
        this.$store.dispatch('interventions/days/get', body)
          .then(async res => {
            this.item = res.data.data
            await this.getTimeWorkedPerDamages()
            this.authUser = true
          })
          .catch(error => {
            const altText = "el daño"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
      else this.authUser = true
      await this.getWastes(true)
      if (day_id) this.step++
    }
  },
  async created () {
    this.init()
  }
}
</script>
